import {CopilotIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

export interface CopilotAssignmentButtonProps {
  onClick: () => void
}

export function CopilotAssignmentButton({onClick}: CopilotAssignmentButtonProps) {
  return (
    <Button leadingVisual={CopilotIcon} size="small" onClick={onClick}>
      Assign to Copilot
    </Button>
  )
}

try{ CopilotAssignmentButton.displayName ||= 'CopilotAssignmentButton' } catch {}